<div class="redWrapper progress">
  <div class="progress-bar" [ngStyle]="{'width' : percent + '%'}" id="progressBar"></div>
</div>
